<template>
    <campus-signup :contact-id="this.contactId"
                   :contact-type="this.contactType"
                   :parent-merchant-id="this.merchantId"
                   :type-merchant="this.typeMerchant"
                   :type-wholesaler="this.typeWholesaler"
                   :type-admin="this.typeAdmin"
                   :merchants="this.merchants"
                   class="my-3 my-md-5 rounded"></campus-signup>
</template>

<script>

import campusSignup from '../components/Campus/Signup';

export default {
    name: 'Campus',
    components: {
        campusSignup,
    },
    props: {
        'contactId': null,
        'contactType': null,
        'merchantId': null,
        typeMerchant: {
            type: String,
        },
        typeWholesaler: {
            type: String,
        },
        typeAdmin: {
            type: String,
        },
        merchants: {
            type: Array,
        },
    },
    data: function() {
        return {};
    },
};
</script>
